module.exports = __webpack_public_path__ + "img/Group 933one.d17d4610.svg";